import { LatLng } from "leaflet";
import { useState, useContext } from "react";
import { useMap, useMapEvents } from "react-leaflet";
import { ToolContext } from "../../context/ToolContext";
import Arrow from "../assets/annotations/Arrow";

interface ArrowDrawProps {
  onDraw: (geometry: LatLng[], startSnapAssetId: string, endSnapAssetId: string) => void;
}

const ArrowDrawTool = ({ onDraw }: ArrowDrawProps) => {
  const [start, setStart] = useState<LatLng>();
  const [end, setEnd] = useState<LatLng>();
  const [startSnapAssetId, setStartSnapAssetId] = useState<string>("");
  const map = useMap();
  const { toolState, setToolState } = useContext(ToolContext);
  const { snapTargetAssetId, snapExcludedAssetId } = toolState;

  const clearSnapExcludedAssetId = () => {
    const _toolState = {
      ...toolState,
      snapExcludedAssetId: "",
    };
    setToolState(_toolState);
  };

  const setSnapExcludedAssetId = (assetId: string) => {
    const _toolState = {
      ...toolState,
      snapExcludedAssetId: assetId,
      snapTargetAssetId: "",
    };
    setToolState(_toolState);
  };

  useMapEvents({
    click(e) {
      if (start && end) {
        const endSnapAssetId: string = (snapTargetAssetId as string) ?? "";
        onDraw([start, end], startSnapAssetId, endSnapAssetId);
        clearSnapExcludedAssetId();
        setStart(undefined);
        setEnd(undefined);
        return;
      }

      setStart(e.latlng);
      setStartSnapAssetId((snapTargetAssetId as string) ?? "");
      setSnapExcludedAssetId((snapTargetAssetId as string) ?? "");
    },
    mousemove(e) {
      if (start) {
        setEnd(e.latlng);
      } else if (!!snapExcludedAssetId) {
        clearSnapExcludedAssetId();
      }
    },
  });

  return start !== undefined && end !== undefined ? (
    <Arrow
      positions={[start, end]}
      isHighlighted={true}
      zoomLevel={map.getZoom()}
      interactive={false}
      easyClickTolerance={0}
    />
  ) : null;
};

export default ArrowDrawTool;
